export default {
  GIVE_FEEDBACK: `Give feedback`,
  GIVE_FEEDBACK_MERINIO: `To Merinio`,
  GIVE_FEEDBACK_EMPLOYER: `To my employer`,
  FEEDBACK_TEXTAREA: {
    PLACEHOLDER: `Write down your feedback here`,
    DESCRIPTION: ``,
    LABEL: ``
  },
  FEEDBACK_MODAL_NONE: {
    TITLE: `Give feedback`,
    SUMMARY: `Who do you want to give feedback to?`
  },
  FEEDBACK_MODAL_MERINIO: {
    TITLE: `Give feedback to Merinio`,
    SUMMARY: `Use this form to tell us about your experience with Merinio, don't hesitate to report bugs, submit issues or show interest in a potential feature. We can't solve your problems if we don't know about them!`
  },
  FEEDBACK_MODAL_EMPLOYER: {
    NOT_SUPPORTED: `This feature has not been set up, you should ask your manager where to send your feedback so your employer sees it.`,
    TITLE: `Give your employer feedback`,
    SUMMARY: `Feedback given through this form will be sent to an email configured by your employer.`
  }
}
